<template>
  <div>
    <!-- <h2>Odkazy</h2> -->
    <ul>
      <li>
        <a href="http://www.mzcr.cz" target="_blank"
          >Ministerstvo zdravotnictví</a
        >
      </li>
      <li>
        <a href="https://www.uzis.cz" target="_blank">ÚZIS ČR</a>
      </li>
      <li>
        <a href="http://geoportal.gov.cz" target="_blank"
          >Geoportál České republiky</a
        >
      </li>
      <li>
        <a href="http://www.szu.cz" target="_blank">Státní zdravotní ústav</a>
      </li>
      <li>
        <a href="http://www.cenia.cz" target="_blank"
          >Česká agentura životního prostředí</a
        >
      </li>
      <li>
        <a href="http://www.czecot.cz/?id_tema=385" target="_blank"
          >Turistický portál ČR</a
        >
      </li>
      <li>
        <a href="http://www.eyeonearth.eu/" target="_blank">Eye on Earth</a>
      </li>
      <li>
        <a
          href="http://www.mzcr.cz/Legislativa/dokumenty/hygiena-deti-a-mladistvych_3546_1789_11.html"
          target="_blank"
          >Hygiena dětí a mladistvých</a
        >
      </li>
      <li>
        <a
          href="http://www.mzcr.cz/Legislativa/dokumenty/spolecne-predpisy-a-instrukce_3543_1789_11.html"
          target="_blank"
          >Společné předpisy ochrana veřejného zdraví</a
        >
      </li>
    </ul>

    <h3>Weby o letních dětských táborech</h3>

    <ul>
      <li>
        <a href="http://www.a-tom.cz/" target="_blank">
          Asociace turistických oddílů mládeže ČR
        </a>
      </li>
      <li>
        <a href="http://www.tabornici.cz/" target="_blank"
          >Česká tábornická unie</a
        >
      </li>
      <li>
        <a href="http://www.duha.cz/" target="_blank"
          >DUHA – Sdružení dětí a mládeže v ČR</a
        >
      </li>
      <li>
        <a href="http://verejnost.skaut.cz/cz/" target="_blank">
          Junák – svaz skautů a skautek ČR
        </a>
      </li>
      <li>
        <a href="http://www.kondor.info/" target="_blank">
          Kondor – Konfederace nezávislých-dětská organizace
        </a>
      </li>
      <li>
        <a href="http://www.pionyr.cz/" target="_blank">Pionýr</a>
      </li>
      <li>
        <a href="http://www.smop.cz/" target="_blank">
          Sdružení mladých ochránců přírody ČSOP
        </a>
      </li>
    </ul>

    <h3>Krajské hygienické stanice</h3>

    <ul>
      <li>
        <a href="http://www.hygpraha.cz/index.php?sum=NA==" target="_blank">
          HS hlavního města Prahy
        </a>
      </li>
      <li>
        <a
          href="http://www.khscb.cz/view.php?cisloclanku=2010050007"
          target="_blank"
        >
          KHS Jihočeského kraje se sídlem v Českých Budějovicích
        </a>
      </li>
      <li>
        <a href="http://www.khsbrno.cz" target="_blank">
          KHS Jihomoravského kraje se sídlem v Brně
        </a>
      </li>
      <li>
        <a href="http://www.khskv.cz" target="_blank">
          KHS Karlovarského kraje se sídlem v Karlových Varech
        </a>
      </li>
      <li>
        <a href="http://www.khsjih.cz/index.php?id=159" target="_blank">
          KHS kraje Vysočina se sídlem v Jihlavě
        </a>
      </li>
      <li>
        <a
          href="http://www.khskk.cz/articles.php?article_id=134"
          target="_blank"
        >
          KHS Královéhradeckého kraje se sídlem v Hradci Králové
        </a>
      </li>
      <li>
        <a href="http://www.khslbc.cz" target="_blank">
          KHS Libereckého kraje se sídlem v Liberci
        </a>
      </li>
      <li>
        <a
          href="http://www.khsova.cz/01_obcanum/kvalita_vody.php"
          target="_blank"
        >
          KHS Moravskoslezského kraje se sídlem v Ostravě
        </a>
      </li>
      <li>
        <a href="http://www.khsolc.cz/obcanum.aspx" target="_blank">
          KHS Olomouckého kraje se sídlem v Olomouci
        </a>
      </li>
      <li>
        <a href="http://www.khspce.cz" target="_blank">
          KHS Pardubického kraje se sídlem v Pardubicích
        </a>
      </li>
      <li>
        <a
          href="http://www.khsplzen.cz/index.php/koupani-ve-volne-pirod/kvalita-vody-koupacich-mist"
          target="_blank"
          >KHS Plzeňského kraje se sídlem v Plzni</a
        >
      </li>
      <li>
        <a href="http://www.khsstc.cz/koupaliste.aspx" target="_blank">
          KHS Středočeského kraje se sídlem v Praze
        </a>
      </li>
      <li>
        <a href="http://www.khsusti.cz/php/koupani/koupani.php" target="_blank">
          KHS Ústeckého kraje se sídlem v Ústí nad Labem
        </a>
      </li>
      <li>
        <a
          href="http://www.khszlin.cz/Koupaci_sezona/koup0.htm"
          target="_blank"
        >
          KHS Zlínského kraje se sídlem ve Zlíně
        </a>
      </li>
    </ul>

    <h3>Zdravotní ústavy</h3>

    <ul>
      <li>
        <a href="http://www.zuova.cz" target="_blank">ZU se sídlem v Ostravě</a>
      </li>
      <li>
        <a href="http://www.zuusti.cz" target="_blank"
          >ZU se sídlem v Ústí nad Labem</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "Odkazy");
  }
};
</script>

<style scoped>
ul {
  padding-left: 10px;
  list-style-type: none;
}

a:link {
  text-decoration: none;
  color: black;
}

a:visited {
  text-decoration: none;
  color: black;
}

a:hover {
  text-decoration: underline;
  color: black;
}

a:active {
  text-decoration: none;
  color: black;
}
</style>
